export default "__VITE_ASSET__93e5fc3e__"